import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTombIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4.75 12.5L4.03604 4.88444C4.01285 4.63705 4.08259 4.38988 4.23168 4.1911L4.45 3.9C4.63885 3.64819 4.93524 3.5 5.25 3.5H5.63628C5.86617 3.5 6.0836 3.3955 6.22721 3.21598V3.21598C7.13606 2.07992 8.86394 2.07992 9.77279 3.21598V3.21598C9.9164 3.3955 10.1338 3.5 10.3637 3.5H10.75C11.0648 3.5 11.3611 3.64819 11.55 3.9L11.7683 4.1911C11.9174 4.38988 11.9872 4.63705 11.964 4.88444L11.25 12.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M2 14V14C5.63331 11.5778 10.3667 11.5778 14 14V14" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.5 6.75H9.5M8 9.5V5.5" })
	]
});
export default SvgTombIcon;
